import Swiper, { Navigation, Pagination, Keyboard, A11y } from "swiper";

const sliderHero = new Swiper(".slider-hero", {
	modules: [Navigation, Pagination, Keyboard, A11y ],
	spaceBetween: 0,
	loop: true,
	threshold: 10,
	autoHeight: true,
	keyboard: {
		enabled: true,
		onlyInViewport: true,
	},
	pagination: {
		el: ".slider-hero-pagination",
		clickable: true,
	},
	navigation: {
		nextEl: ".slider-hero-next",
		prevEl: ".slider-hero-prev",
	},
	a11y: {
		prevSlideMessage: "Vorheriger Slide",
		nextSlideMessage: "Nächster Slide",
		paginationBulletMessage: "Gehe zum {{index}} Slide"
	  },
});

const sliderTestimonial = new Swiper(".slider-testimonial", {
	modules: [Navigation, Pagination, Keyboard, A11y ],
	spaceBetween: 40,
	loop: true,
	threshold: 10,
	autoHeight: true,
	keyboard: {
		enabled: true,
		onlyInViewport: true,
	},
	pagination: {
		el: ".slider-testimonial-pagination",
		clickable: true,
	},
	navigation: {
		nextEl: ".slider-testimonial-next",
		prevEl: ".slider-testimonial-prev",
	},
	a11y: {
		prevSlideMessage: "Vorheriger Slide",
		nextSlideMessage: "Nächster Slide",
		paginationBulletMessage: "Gehe zum {{index}} Slide"
	  },
});